import React, { useEffect, useState, useMemo } from "react";
import classes from "../../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get, deleteRecord, put, post } from "../../../server";
import {
  CHATBOT_KNOWLEDGE_BASE,
  FEEDBACK,
  PRODUCT_DISCOUNT,
} from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { BsThreeDotsVertical } from "react-icons/bs";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import { useParams } from "react-router-dom";
import { Button, Card, Form, Modal } from "react-bootstrap";
import { FaAngry } from "react-icons/fa";
import { FaGrinHearts } from "react-icons/fa";
import { ImSad2 } from "react-icons/im";
import { FaMeh } from "react-icons/fa";
import { FaSmileBeam } from "react-icons/fa";
import baseURL from "../../../utils/constants/baseUrl";

const ChatbotKnowledgeBaseList = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [errors, setErrors] = useState({});
  const [discounts, setDiscounts] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [statusId, setStatusId] = useState(null);
  const [feedbackViewModal, setFeedbackViewModal] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  let { id } = useParams();
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const handleCloseFeedbackModal = () => {
    setFeedbackViewModal(false);
  };

  const loadKnowledgeBaseList = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      CHATBOT_KNOWLEDGE_BASE,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      // if (data.length > 0) {
      setDiscounts(data);
      const status = data.map((statusValue) => statusValue.status);
      setStatusId(status);
      // }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = discounts.filter(
      (item) =>
        `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.package.package_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.discount || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, discounts]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Document Name",
      cell: (row) => <p className="globalDetail">{`${row?.document_name}`}</p>,
    },
    {
      name: "Date",
      cell: (row) => {
        const creationDate = new Date(row?.created_at);
        const formattedDate = creationDate.toLocaleString();
        return (
          <p className="globalDetail">
            {row?.created_at ? formattedDate : "-"}
          </p>
        );
      },
    },
    {
      name: "Action",
      width: "100px",
      right: "true",
      cell: (row, index) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                // onClick={() => {
                //   setFeedbackViewModal(true);
                // }}
                onClick={() => {
                  window.open(
                    `${baseURL.AWS_URL}${row?.document_file}`,
                    "_blank"
                  );
                }}
              >
                View
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (discountId) => {
    setDeleteId(discountId);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${CHATBOT_KNOWLEDGE_BASE}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadKnowledgeBaseList();
      setLoading(false);
    }
    setLoading(false);
  };

  const updateStatus = async (discountId) => {
    setLoading(true);
    setStatusId(discountId);
    let newStatus = 1;
    const discountIndex = discounts.findIndex((pkg) => pkg.id === discountId);
    if (discountIndex !== -1) {
      if (statusId[discountIndex] === 1) {
        newStatus = 0;
      }
    }
    const payload = {
      status: newStatus,
    };
    let { status, message } = await put(
      `${PRODUCT_DISCOUNT}/${discountId}/update/status`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadKnowledgeBaseList();
      setLoading(false);
    }
    setLoading(false);
  };

  const handleFileUpload = async () => {
    if (selectedFiles.length === 0) {
      showToast(false, "Please select at least one file.");
      return;
    }

    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("file[]", file); // send as an array with "file[]" key
    });

    setLoading(true);

    const { status, message } = await post(
      CHATBOT_KNOWLEDGE_BASE,
      formData,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null,
      true // indicates it's multipart/form-data
    );

    if (status) {
      showToast(true, "File(s) uploaded successfully.");
      setFeedbackViewModal(false);
      setSelectedFiles([]);
      await loadKnowledgeBaseList();
    } else {
      showToast(false, message || "File upload failed.");
    }

    setLoading(false);
  };

  useEffect(() => {
    loadKnowledgeBaseList();
  }, []);

  return (
    <>
      {!loading ? (
        <div>
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-4">
              <div className="heading">
                <h1 className="mb-0">
                  Customer Feedback <span>({discounts.length})</span>
                </h1>
              </div>
              <div className="d-flex align-items-center justify-content gap-2 mb-2">
                <div className="d-flex justify-content-end gap-2 mobileViewWrapper">
                  <Button
                    variant="primary"
                    onClick={() => {
                      setFeedbackViewModal(true);
                    }}
                  >
                    Add Document
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="coupon"
          />
          <Modal
            size="md"
            show={feedbackViewModal}
            onHide={handleCloseFeedbackModal}
            aria-labelledby="contained-modal-title-vcenter"
            // className="customModal"
          >
            <Modal.Header>
              <h5 className="mb-0">Add Knowledgebase File</h5>
            </Modal.Header>
            <Modal.Body
              className={`d-flex justify-content-center flex-column align-items-center`}
            >
              <div className="container">
                <div className="row justify-content-center align-items-center">
                  <div className="col-12">
                    <Card>
                      <Card.Body>
                        <Form className="feedback-form">
                          <div className="form-group mb-2">
                            <label className="form-label">Upload File</label>
                            <input
                              className="form-control"
                              type="file"
                              multiple
                              onChange={(e) =>
                                setSelectedFiles(Array.from(e.target.files))
                              }
                            />
                          </div>
                        </Form>
                        <div className="text-end">
                          <Button
                            variant="outline-primary"
                            className="mt-4"
                            onClick={handleCloseFeedbackModal}
                          >
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            className="mt-4 ms-2"
                            onClick={handleFileUpload}
                          >
                            Upload
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default ChatbotKnowledgeBaseList;
